// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"SocialIcons__materialize-textarea___2RdfQ","modal-2463794813":"SocialIcons__modal-2463794813___FpMZm","container":"SocialIcons__container___Gu4Y5","socialIconContainer":"SocialIcons__socialIconContainer___1YBi7","copyRight":"SocialIcons__copyRight___1Ix3A","connectWithUs":"SocialIcons__connectWithUs___3j0TR","socialIcons":"SocialIcons__socialIcons____dOxd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialIcons/SocialIcons.scss
// module id = 1536
// module chunks = 0